import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * 페이지 상태 스토어 — "지금 경로의 데이터가 없다(not-found)" 신호를 head 컴포저블에 전달한다.
 *
 * 동적 색인 라우트(`/notice/:id`·`/products/:code`·`/guide/:slug`)는 경로 패턴만으로는 색인 대상이지만, 데이터가 없으면
 * "찾을 수 없음" 화면을 200 으로 그린다(SPA·폴백 셸). 이 상태로 canonical 을 내면 soft 404 가 색인된다.
 * 페이지가 `usePageNotFound` 로 여기에 표시하면 `useRouteHead` 는 noindex 를, `useCanonicalHead` 는 canonical 생략을 한다.
 *
 * 값은 **경로로 묶는다** — 라우트가 바뀌면 다른 경로의 표시는 자동으로 무효라 별도 초기화 타이밍에 의존하지 않는다.
 * Pinia 는 앱 인스턴스별이라 SSG 프리렌더(라우트 병렬 렌더)에서도 서로 섞이지 않는다.
 */
export const usePageStatusStore = defineStore('pageStatus', () => {
  /** 데이터 없음으로 표시된 경로(`route.path`). 없으면 null. */
  const notFoundPath = ref<string | null>(null);

  function markNotFound(path: string, notFound: boolean): void {
    if (notFound) notFoundPath.value = path;
    else if (notFoundPath.value === path) notFoundPath.value = null;
  }

  function isNotFound(path: string): boolean {
    return notFoundPath.value === path;
  }

  return { notFoundPath, markNotFound, isNotFound };
});
